import {
    FullAudit,
    IsActiveFlag,
    LevelModel,
    NumberModel,
    RoleModel,
    UserDeviceModel,
    UserExtensionModel,
    UserIntegrationModel,
    UserQueueStatusHistoryModel,
    QueueModel,
} from '@/types';

export interface UserModel extends IsActiveFlag, FullAudit {
    id: number;
    name: string;
    email: string;
    standardLevelId?: number;
    standardLevel?: LevelModel;
    useSmartCallerId?: boolean;
    useAutoAttendant?: boolean;
    hasMeeting?: boolean;
    lastLogin?: string;
    lastDeviceLogin?: string;
    levels?: LevelModel[];
    roles?: RoleModel[];
    numbers?: NumberModel[];
    integrations?: UserIntegrationModel[];
    devices?: UserDeviceModel[];
    extension?: UserExtensionModel;
    queueStatusHistory?: UserQueueStatusHistoryModel[];
    queues?: QueueModel[];
    requiresTwoFactor: boolean;
    twoFactorEnabled: boolean;
    isPasswordExpired: boolean;
    hasWhatsappCode?: boolean;
    hasWhatsAppMeta?: boolean;
    currentLevel?: LevelModel;
}
